// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import social from './social.svg';

interface SocialIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: SocialNames;
}

export function SocialIcon({ name, ...props }: SocialIconProps) {
  return <Icon {...props} link={social} name={name} />
}

type SocialNames =
  | '18_up_rating'
  | '6_ft_apart'
  | 'add_moderator'
  | 'add_reaction'
  | 'architecture'
  | 'back_hand'
  | 'boy'
  | 'cake'
  | 'catching_pokemon'
  | 'clean_hands'
  | 'co2'
  | 'compost'
  | 'connect_without_contact'
  | 'construction'
  | 'cookie'
  | 'coronavirus'
  | 'cruelty_free'
  | 'cyclone'
  | 'deck'
  | 'domain_add'
  | 'domain'
  | 'downhill_skiing'
  | 'edit_notifications'
  | 'elderly_woman'
  | 'elderly'
  | 'emoji_emotions'
  | 'emoji_events'
  | 'emoji_food_beverage'
  | 'emoji_nature'
  | 'emoji_objects_outline'
  | 'emoji_objects'
  | 'emoji_people'
  | 'emoji_symbols'
  | 'emoji_transportation'
  | 'engineering'
  | 'fireplace'
  | 'fitbit'
  | 'flood'
  | 'follow_the_signs'
  | 'front_hand'
  | 'girl'
  | 'group_add'
  | 'group_off'
  | 'group_remove'
  | 'group'
  | 'groups'
  | 'handshake'
  | 'health_and_safety'
  | 'heart_broken'
  | 'hiking'
  | 'history_edu'
  | 'hive'
  | 'ice_skating'
  | 'interests'
  | 'kayaking'
  | 'king_bed'
  | 'kitesurfing'
  | 'landslide'
  | 'location_city'
  | 'luggage'
  | 'man'
  | 'masks'
  | 'military_tech'
  | 'mood_bad'
  | 'mood'
  | 'nights_stay'
  | 'no_adult_content'
  | 'no_luggage'
  | 'nordic_walking'
  | 'notification_add'
  | 'notifications_active'
  | 'notifications_none'
  | 'notifications_paused'
  | 'outdoor_grill'
  | 'pages'
  | 'paragliding'
  | 'party_mode'
  | 'people_alt'
  | 'people_outline'
  | 'person_add_alt_1'
  | 'person_add_alt'
  | 'person_add'
  | 'person_off'
  | 'person_outline'
  | 'person_remove_alt_1'
  | 'person_remove'
  | 'personal_injury'
  | 'piano_off'
  | 'piano'
  | 'pix'
  | 'plus_one'
  | 'poll'
  | 'precision_manufacturing'
  | 'psychology'
  | 'public_off'
  | 'public'
  | 'real_estate_agent'
  | 'recommend'
  | 'recycling'
  | 'reduce_capacity'
  | 'remove_moderator'
  | 'roller_skating'
  | 'safety_divider'
  | 'sanitizer'
  | 'scale'
  | 'school'
  | 'science'
  | 'scoreboard'
  | 'scuba_diving'
  | 'self_improvement'
  | 'sentiment_dissatisfied'
  | 'sentiment_neutral'
  | 'sentiment_satisfied'
  | 'sentiment_very_dissatisfied'
  | 'sentiment_very_satisfied'
  | 'severe_cold'
  | 'share'
  | 'sick'
  | 'sign_language'
  | 'single_bed'
  | 'skateboarding'
  | 'sledding'
  | 'snowboarding'
  | 'snowshoeing'
  | 'social_distance'
  | 'south_america'
  | 'sports_baseball'
  | 'sports_basketball'
  | 'sports_cricket'
  | 'sports_esports'
  | 'sports_football'
  | 'sports_golf'
  | 'sports_gymnastics'
  | 'sports_handball'
  | 'sports_hockey'
  | 'sports_kabaddi'
  | 'sports_martial_arts'
  | 'sports_mma'
  | 'sports_motorsports'
  | 'sports_rugby'
  | 'sports_soccer'
  | 'sports_tennis'
  | 'sports_volleyball'
  | 'sports'
  | 'surfing'
  | 'switch_account'
  | 'thumb_down_alt'
  | 'thumb_up_alt'
  | 'thunderstorm'
  | 'tornado'
  | 'transgender'
  | 'travel_explore'
  | 'tsunami'
  | 'vaccines'
  | 'volcano'
  | 'water_drop'
  | 'waving_hand'
  | 'whatsapp'
  | 'whatshot'
  | 'woman'
  | 'workspace_premium'
;

